/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SuspendedRouteImport } from './routes/suspended'
import { Route as SubscriberRouteImport } from './routes/subscriber'
import { Route as SubscribeRouteImport } from './routes/subscribe'
import { Route as DonateRouteImport } from './routes/donate'
import { Route as CreatorRouteImport } from './routes/creator'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as R404RouteImport } from './routes/404'
import { Route as R403RouteImport } from './routes/403'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SubscriberIndexRouteImport } from './routes/subscriber.index'
import { Route as CreatorIndexRouteImport } from './routes/creator.index'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as VideosSlugRouteImport } from './routes/videos.$slug'
import { Route as SubscriberWelcomeRouteImport } from './routes/subscriber.welcome'
import { Route as SubscriberSettingsRouteImport } from './routes/subscriber.settings'
import { Route as SubscriberSavedRouteImport } from './routes/subscriber.saved'
import { Route as SubscriberHistoryRouteImport } from './routes/subscriber.history'
import { Route as SubscriberFeedRouteImport } from './routes/subscriber.feed'
import { Route as SubscriberDiscoverRouteImport } from './routes/subscriber.discover'
import { Route as SubscriberContributorsRouteImport } from './routes/subscriber.contributors'
import { Route as StudioSlugRouteImport } from './routes/studio.$slug'
import { Route as OnboardingWelcomeRouteImport } from './routes/onboarding/welcome'
import { Route as OnboardingSubscriberRouteImport } from './routes/onboarding/subscriber'
import { Route as OnboardingCreatorRouteImport } from './routes/onboarding/creator'
import { Route as LiveSlugRouteImport } from './routes/live.$slug'
import { Route as EgressSlugRouteImport } from './routes/egress.$slug'
import { Route as CreatorWriteRouteImport } from './routes/creator.write'
import { Route as CreatorUploadRouteImport } from './routes/creator.upload'
import { Route as CreatorStudioRouteImport } from './routes/creator.studio'
import { Route as CreatorShowsRouteImport } from './routes/creator.shows'
import { Route as CreatorSettingsRouteImport } from './routes/creator.settings'
import { Route as CreatorLiveRouteImport } from './routes/creator.live'
import { Route as CreatorContentRouteImport } from './routes/creator.content'
import { Route as CreatorAssetsRouteImport } from './routes/creator.assets'
import { Route as CreatorApplicationStatusRouteImport } from './routes/creator.application-status'
import { Route as CreatorAnalyticsRouteImport } from './routes/creator.analytics'
import { Route as AuthVerifyRouteImport } from './routes/auth/verify'
import { Route as AuthUpdatePasswordRouteImport } from './routes/auth/update-password'
import { Route as AuthSignUpRouteImport } from './routes/auth/sign-up'
import { Route as AuthSignInRouteImport } from './routes/auth/sign-in'
import { Route as AuthResetPasswordRouteImport } from './routes/auth/reset-password'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as ArticlesSlugRouteImport } from './routes/articles.$slug'
import { Route as AdminUsersRouteImport } from './routes/admin.users'
import { Route as AdminSymbolsRouteImport } from './routes/admin.symbols'
import { Route as AdminStudioRouteImport } from './routes/admin.studio'
import { Route as AdminShowsRouteImport } from './routes/admin.shows'
import { Route as AdminPicksRouteImport } from './routes/admin.picks'
import { Route as AdminMenuRouteImport } from './routes/admin.menu'
import { Route as AdminMastheadRouteImport } from './routes/admin.masthead'
import { Route as AdminLiveRouteImport } from './routes/admin.live'
import { Route as AdminInvitesRouteImport } from './routes/admin.invites'
import { Route as AdminCorrectionsRouteImport } from './routes/admin.corrections'
import { Route as AdminCopyRouteImport } from './routes/admin.copy'
import { Route as AdminContentRouteImport } from './routes/admin.content'
import { Route as AdminCategoriesRouteImport } from './routes/admin.categories'
import { Route as AdminAuditRouteImport } from './routes/admin.audit'
import { Route as AdminApplicationsRouteImport } from './routes/admin.applications'
import { Route as SubscriberHistoryIndexRouteImport } from './routes/subscriber.history.index'
import { Route as CreatorContentIndexRouteImport } from './routes/creator.content.index'
import { Route as SubscriberHistoryWatchingRouteImport } from './routes/subscriber.history.watching'
import { Route as SubscriberHistoryReadingRouteImport } from './routes/subscriber.history.reading'
import { Route as SubscriberCreatorsUsernameRouteImport } from './routes/subscriber.creators.$username'
import { Route as CreatorContentContentIdPreviewRouteImport } from './routes/creator.content.$contentId.preview'
import { Route as CreatorContentContentIdEditRouteImport } from './routes/creator.content.$contentId.edit'

const SuspendedRoute = SuspendedRouteImport.update({
  id: '/suspended',
  path: '/suspended',
  getParentRoute: () => rootRouteImport,
} as any)
const SubscriberRoute = SubscriberRouteImport.update({
  id: '/subscriber',
  path: '/subscriber',
  getParentRoute: () => rootRouteImport,
} as any)
const SubscribeRoute = SubscribeRouteImport.update({
  id: '/subscribe',
  path: '/subscribe',
  getParentRoute: () => rootRouteImport,
} as any)
const DonateRoute = DonateRouteImport.update({
  id: '/donate',
  path: '/donate',
  getParentRoute: () => rootRouteImport,
} as any)
const CreatorRoute = CreatorRouteImport.update({
  id: '/creator',
  path: '/creator',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const R404Route = R404RouteImport.update({
  id: '/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const R403Route = R403RouteImport.update({
  id: '/403',
  path: '/403',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SubscriberIndexRoute = SubscriberIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SubscriberRoute,
} as any)
const CreatorIndexRoute = CreatorIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CreatorRoute,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const VideosSlugRoute = VideosSlugRouteImport.update({
  id: '/videos/$slug',
  path: '/videos/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const SubscriberWelcomeRoute = SubscriberWelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => SubscriberRoute,
} as any)
const SubscriberSettingsRoute = SubscriberSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => SubscriberRoute,
} as any)
const SubscriberSavedRoute = SubscriberSavedRouteImport.update({
  id: '/saved',
  path: '/saved',
  getParentRoute: () => SubscriberRoute,
} as any)
const SubscriberHistoryRoute = SubscriberHistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => SubscriberRoute,
} as any)
const SubscriberFeedRoute = SubscriberFeedRouteImport.update({
  id: '/feed',
  path: '/feed',
  getParentRoute: () => SubscriberRoute,
} as any)
const SubscriberDiscoverRoute = SubscriberDiscoverRouteImport.update({
  id: '/discover',
  path: '/discover',
  getParentRoute: () => SubscriberRoute,
} as any)
const SubscriberContributorsRoute = SubscriberContributorsRouteImport.update({
  id: '/contributors',
  path: '/contributors',
  getParentRoute: () => SubscriberRoute,
} as any)
const StudioSlugRoute = StudioSlugRouteImport.update({
  id: '/studio/$slug',
  path: '/studio/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingWelcomeRoute = OnboardingWelcomeRouteImport.update({
  id: '/onboarding/welcome',
  path: '/onboarding/welcome',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingSubscriberRoute = OnboardingSubscriberRouteImport.update({
  id: '/onboarding/subscriber',
  path: '/onboarding/subscriber',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingCreatorRoute = OnboardingCreatorRouteImport.update({
  id: '/onboarding/creator',
  path: '/onboarding/creator',
  getParentRoute: () => rootRouteImport,
} as any)
const LiveSlugRoute = LiveSlugRouteImport.update({
  id: '/live/$slug',
  path: '/live/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const EgressSlugRoute = EgressSlugRouteImport.update({
  id: '/egress/$slug',
  path: '/egress/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const CreatorWriteRoute = CreatorWriteRouteImport.update({
  id: '/write',
  path: '/write',
  getParentRoute: () => CreatorRoute,
} as any)
const CreatorUploadRoute = CreatorUploadRouteImport.update({
  id: '/upload',
  path: '/upload',
  getParentRoute: () => CreatorRoute,
} as any)
const CreatorStudioRoute = CreatorStudioRouteImport.update({
  id: '/studio',
  path: '/studio',
  getParentRoute: () => CreatorRoute,
} as any)
const CreatorShowsRoute = CreatorShowsRouteImport.update({
  id: '/shows',
  path: '/shows',
  getParentRoute: () => CreatorRoute,
} as any)
const CreatorSettingsRoute = CreatorSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => CreatorRoute,
} as any)
const CreatorLiveRoute = CreatorLiveRouteImport.update({
  id: '/live',
  path: '/live',
  getParentRoute: () => CreatorRoute,
} as any)
const CreatorContentRoute = CreatorContentRouteImport.update({
  id: '/content',
  path: '/content',
  getParentRoute: () => CreatorRoute,
} as any)
const CreatorAssetsRoute = CreatorAssetsRouteImport.update({
  id: '/assets',
  path: '/assets',
  getParentRoute: () => CreatorRoute,
} as any)
const CreatorApplicationStatusRoute =
  CreatorApplicationStatusRouteImport.update({
    id: '/application-status',
    path: '/application-status',
    getParentRoute: () => CreatorRoute,
  } as any)
const CreatorAnalyticsRoute = CreatorAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => CreatorRoute,
} as any)
const AuthVerifyRoute = AuthVerifyRouteImport.update({
  id: '/auth/verify',
  path: '/auth/verify',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthUpdatePasswordRoute = AuthUpdatePasswordRouteImport.update({
  id: '/auth/update-password',
  path: '/auth/update-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSignUpRoute = AuthSignUpRouteImport.update({
  id: '/auth/sign-up',
  path: '/auth/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSignInRoute = AuthSignInRouteImport.update({
  id: '/auth/sign-in',
  path: '/auth/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/auth/reset-password',
  path: '/auth/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const ArticlesSlugRoute = ArticlesSlugRouteImport.update({
  id: '/articles/$slug',
  path: '/articles/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSymbolsRoute = AdminSymbolsRouteImport.update({
  id: '/symbols',
  path: '/symbols',
  getParentRoute: () => AdminRoute,
} as any)
const AdminStudioRoute = AdminStudioRouteImport.update({
  id: '/studio',
  path: '/studio',
  getParentRoute: () => AdminRoute,
} as any)
const AdminShowsRoute = AdminShowsRouteImport.update({
  id: '/shows',
  path: '/shows',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPicksRoute = AdminPicksRouteImport.update({
  id: '/picks',
  path: '/picks',
  getParentRoute: () => AdminRoute,
} as any)
const AdminMenuRoute = AdminMenuRouteImport.update({
  id: '/menu',
  path: '/menu',
  getParentRoute: () => AdminRoute,
} as any)
const AdminMastheadRoute = AdminMastheadRouteImport.update({
  id: '/masthead',
  path: '/masthead',
  getParentRoute: () => AdminRoute,
} as any)
const AdminLiveRoute = AdminLiveRouteImport.update({
  id: '/live',
  path: '/live',
  getParentRoute: () => AdminRoute,
} as any)
const AdminInvitesRoute = AdminInvitesRouteImport.update({
  id: '/invites',
  path: '/invites',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCorrectionsRoute = AdminCorrectionsRouteImport.update({
  id: '/corrections',
  path: '/corrections',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCopyRoute = AdminCopyRouteImport.update({
  id: '/copy',
  path: '/copy',
  getParentRoute: () => AdminRoute,
} as any)
const AdminContentRoute = AdminContentRouteImport.update({
  id: '/content',
  path: '/content',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCategoriesRoute = AdminCategoriesRouteImport.update({
  id: '/categories',
  path: '/categories',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAuditRoute = AdminAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AdminRoute,
} as any)
const AdminApplicationsRoute = AdminApplicationsRouteImport.update({
  id: '/applications',
  path: '/applications',
  getParentRoute: () => AdminRoute,
} as any)
const SubscriberHistoryIndexRoute = SubscriberHistoryIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SubscriberHistoryRoute,
} as any)
const CreatorContentIndexRoute = CreatorContentIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CreatorContentRoute,
} as any)
const SubscriberHistoryWatchingRoute =
  SubscriberHistoryWatchingRouteImport.update({
    id: '/watching',
    path: '/watching',
    getParentRoute: () => SubscriberHistoryRoute,
  } as any)
const SubscriberHistoryReadingRoute =
  SubscriberHistoryReadingRouteImport.update({
    id: '/reading',
    path: '/reading',
    getParentRoute: () => SubscriberHistoryRoute,
  } as any)
const SubscriberCreatorsUsernameRoute =
  SubscriberCreatorsUsernameRouteImport.update({
    id: '/creators/$username',
    path: '/creators/$username',
    getParentRoute: () => SubscriberRoute,
  } as any)
const CreatorContentContentIdPreviewRoute =
  CreatorContentContentIdPreviewRouteImport.update({
    id: '/$contentId/preview',
    path: '/$contentId/preview',
    getParentRoute: () => CreatorContentRoute,
  } as any)
const CreatorContentContentIdEditRoute =
  CreatorContentContentIdEditRouteImport.update({
    id: '/$contentId/edit',
    path: '/$contentId/edit',
    getParentRoute: () => CreatorContentRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/403': typeof R403Route
  '/404': typeof R404Route
  '/admin': typeof AdminRouteWithChildren
  '/creator': typeof CreatorRouteWithChildren
  '/donate': typeof DonateRoute
  '/subscribe': typeof SubscribeRoute
  '/subscriber': typeof SubscriberRouteWithChildren
  '/suspended': typeof SuspendedRoute
  '/admin/applications': typeof AdminApplicationsRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/categories': typeof AdminCategoriesRoute
  '/admin/content': typeof AdminContentRoute
  '/admin/copy': typeof AdminCopyRoute
  '/admin/corrections': typeof AdminCorrectionsRoute
  '/admin/invites': typeof AdminInvitesRoute
  '/admin/live': typeof AdminLiveRoute
  '/admin/masthead': typeof AdminMastheadRoute
  '/admin/menu': typeof AdminMenuRoute
  '/admin/picks': typeof AdminPicksRoute
  '/admin/shows': typeof AdminShowsRoute
  '/admin/studio': typeof AdminStudioRoute
  '/admin/symbols': typeof AdminSymbolsRoute
  '/admin/users': typeof AdminUsersRoute
  '/articles/$slug': typeof ArticlesSlugRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/sign-in': typeof AuthSignInRoute
  '/auth/sign-up': typeof AuthSignUpRoute
  '/auth/update-password': typeof AuthUpdatePasswordRoute
  '/auth/verify': typeof AuthVerifyRoute
  '/creator/analytics': typeof CreatorAnalyticsRoute
  '/creator/application-status': typeof CreatorApplicationStatusRoute
  '/creator/assets': typeof CreatorAssetsRoute
  '/creator/content': typeof CreatorContentRouteWithChildren
  '/creator/live': typeof CreatorLiveRoute
  '/creator/settings': typeof CreatorSettingsRoute
  '/creator/shows': typeof CreatorShowsRoute
  '/creator/studio': typeof CreatorStudioRoute
  '/creator/upload': typeof CreatorUploadRoute
  '/creator/write': typeof CreatorWriteRoute
  '/egress/$slug': typeof EgressSlugRoute
  '/live/$slug': typeof LiveSlugRoute
  '/onboarding/creator': typeof OnboardingCreatorRoute
  '/onboarding/subscriber': typeof OnboardingSubscriberRoute
  '/onboarding/welcome': typeof OnboardingWelcomeRoute
  '/studio/$slug': typeof StudioSlugRoute
  '/subscriber/contributors': typeof SubscriberContributorsRoute
  '/subscriber/discover': typeof SubscriberDiscoverRoute
  '/subscriber/feed': typeof SubscriberFeedRoute
  '/subscriber/history': typeof SubscriberHistoryRouteWithChildren
  '/subscriber/saved': typeof SubscriberSavedRoute
  '/subscriber/settings': typeof SubscriberSettingsRoute
  '/subscriber/welcome': typeof SubscriberWelcomeRoute
  '/videos/$slug': typeof VideosSlugRoute
  '/admin/': typeof AdminIndexRoute
  '/creator/': typeof CreatorIndexRoute
  '/subscriber/': typeof SubscriberIndexRoute
  '/subscriber/creators/$username': typeof SubscriberCreatorsUsernameRoute
  '/subscriber/history/reading': typeof SubscriberHistoryReadingRoute
  '/subscriber/history/watching': typeof SubscriberHistoryWatchingRoute
  '/creator/content/': typeof CreatorContentIndexRoute
  '/subscriber/history/': typeof SubscriberHistoryIndexRoute
  '/creator/content/$contentId/edit': typeof CreatorContentContentIdEditRoute
  '/creator/content/$contentId/preview': typeof CreatorContentContentIdPreviewRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/403': typeof R403Route
  '/404': typeof R404Route
  '/donate': typeof DonateRoute
  '/subscribe': typeof SubscribeRoute
  '/suspended': typeof SuspendedRoute
  '/admin/applications': typeof AdminApplicationsRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/categories': typeof AdminCategoriesRoute
  '/admin/content': typeof AdminContentRoute
  '/admin/copy': typeof AdminCopyRoute
  '/admin/corrections': typeof AdminCorrectionsRoute
  '/admin/invites': typeof AdminInvitesRoute
  '/admin/live': typeof AdminLiveRoute
  '/admin/masthead': typeof AdminMastheadRoute
  '/admin/menu': typeof AdminMenuRoute
  '/admin/picks': typeof AdminPicksRoute
  '/admin/shows': typeof AdminShowsRoute
  '/admin/studio': typeof AdminStudioRoute
  '/admin/symbols': typeof AdminSymbolsRoute
  '/admin/users': typeof AdminUsersRoute
  '/articles/$slug': typeof ArticlesSlugRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/sign-in': typeof AuthSignInRoute
  '/auth/sign-up': typeof AuthSignUpRoute
  '/auth/update-password': typeof AuthUpdatePasswordRoute
  '/auth/verify': typeof AuthVerifyRoute
  '/creator/analytics': typeof CreatorAnalyticsRoute
  '/creator/application-status': typeof CreatorApplicationStatusRoute
  '/creator/assets': typeof CreatorAssetsRoute
  '/creator/live': typeof CreatorLiveRoute
  '/creator/settings': typeof CreatorSettingsRoute
  '/creator/shows': typeof CreatorShowsRoute
  '/creator/studio': typeof CreatorStudioRoute
  '/creator/upload': typeof CreatorUploadRoute
  '/creator/write': typeof CreatorWriteRoute
  '/egress/$slug': typeof EgressSlugRoute
  '/live/$slug': typeof LiveSlugRoute
  '/onboarding/creator': typeof OnboardingCreatorRoute
  '/onboarding/subscriber': typeof OnboardingSubscriberRoute
  '/onboarding/welcome': typeof OnboardingWelcomeRoute
  '/studio/$slug': typeof StudioSlugRoute
  '/subscriber/contributors': typeof SubscriberContributorsRoute
  '/subscriber/discover': typeof SubscriberDiscoverRoute
  '/subscriber/feed': typeof SubscriberFeedRoute
  '/subscriber/saved': typeof SubscriberSavedRoute
  '/subscriber/settings': typeof SubscriberSettingsRoute
  '/subscriber/welcome': typeof SubscriberWelcomeRoute
  '/videos/$slug': typeof VideosSlugRoute
  '/admin': typeof AdminIndexRoute
  '/creator': typeof CreatorIndexRoute
  '/subscriber': typeof SubscriberIndexRoute
  '/subscriber/creators/$username': typeof SubscriberCreatorsUsernameRoute
  '/subscriber/history/reading': typeof SubscriberHistoryReadingRoute
  '/subscriber/history/watching': typeof SubscriberHistoryWatchingRoute
  '/creator/content': typeof CreatorContentIndexRoute
  '/subscriber/history': typeof SubscriberHistoryIndexRoute
  '/creator/content/$contentId/edit': typeof CreatorContentContentIdEditRoute
  '/creator/content/$contentId/preview': typeof CreatorContentContentIdPreviewRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/403': typeof R403Route
  '/404': typeof R404Route
  '/admin': typeof AdminRouteWithChildren
  '/creator': typeof CreatorRouteWithChildren
  '/donate': typeof DonateRoute
  '/subscribe': typeof SubscribeRoute
  '/subscriber': typeof SubscriberRouteWithChildren
  '/suspended': typeof SuspendedRoute
  '/admin/applications': typeof AdminApplicationsRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/categories': typeof AdminCategoriesRoute
  '/admin/content': typeof AdminContentRoute
  '/admin/copy': typeof AdminCopyRoute
  '/admin/corrections': typeof AdminCorrectionsRoute
  '/admin/invites': typeof AdminInvitesRoute
  '/admin/live': typeof AdminLiveRoute
  '/admin/masthead': typeof AdminMastheadRoute
  '/admin/menu': typeof AdminMenuRoute
  '/admin/picks': typeof AdminPicksRoute
  '/admin/shows': typeof AdminShowsRoute
  '/admin/studio': typeof AdminStudioRoute
  '/admin/symbols': typeof AdminSymbolsRoute
  '/admin/users': typeof AdminUsersRoute
  '/articles/$slug': typeof ArticlesSlugRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/sign-in': typeof AuthSignInRoute
  '/auth/sign-up': typeof AuthSignUpRoute
  '/auth/update-password': typeof AuthUpdatePasswordRoute
  '/auth/verify': typeof AuthVerifyRoute
  '/creator/analytics': typeof CreatorAnalyticsRoute
  '/creator/application-status': typeof CreatorApplicationStatusRoute
  '/creator/assets': typeof CreatorAssetsRoute
  '/creator/content': typeof CreatorContentRouteWithChildren
  '/creator/live': typeof CreatorLiveRoute
  '/creator/settings': typeof CreatorSettingsRoute
  '/creator/shows': typeof CreatorShowsRoute
  '/creator/studio': typeof CreatorStudioRoute
  '/creator/upload': typeof CreatorUploadRoute
  '/creator/write': typeof CreatorWriteRoute
  '/egress/$slug': typeof EgressSlugRoute
  '/live/$slug': typeof LiveSlugRoute
  '/onboarding/creator': typeof OnboardingCreatorRoute
  '/onboarding/subscriber': typeof OnboardingSubscriberRoute
  '/onboarding/welcome': typeof OnboardingWelcomeRoute
  '/studio/$slug': typeof StudioSlugRoute
  '/subscriber/contributors': typeof SubscriberContributorsRoute
  '/subscriber/discover': typeof SubscriberDiscoverRoute
  '/subscriber/feed': typeof SubscriberFeedRoute
  '/subscriber/history': typeof SubscriberHistoryRouteWithChildren
  '/subscriber/saved': typeof SubscriberSavedRoute
  '/subscriber/settings': typeof SubscriberSettingsRoute
  '/subscriber/welcome': typeof SubscriberWelcomeRoute
  '/videos/$slug': typeof VideosSlugRoute
  '/admin/': typeof AdminIndexRoute
  '/creator/': typeof CreatorIndexRoute
  '/subscriber/': typeof SubscriberIndexRoute
  '/subscriber/creators/$username': typeof SubscriberCreatorsUsernameRoute
  '/subscriber/history/reading': typeof SubscriberHistoryReadingRoute
  '/subscriber/history/watching': typeof SubscriberHistoryWatchingRoute
  '/creator/content/': typeof CreatorContentIndexRoute
  '/subscriber/history/': typeof SubscriberHistoryIndexRoute
  '/creator/content/$contentId/edit': typeof CreatorContentContentIdEditRoute
  '/creator/content/$contentId/preview': typeof CreatorContentContentIdPreviewRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/403'
    | '/404'
    | '/admin'
    | '/creator'
    | '/donate'
    | '/subscribe'
    | '/subscriber'
    | '/suspended'
    | '/admin/applications'
    | '/admin/audit'
    | '/admin/categories'
    | '/admin/content'
    | '/admin/copy'
    | '/admin/corrections'
    | '/admin/invites'
    | '/admin/live'
    | '/admin/masthead'
    | '/admin/menu'
    | '/admin/picks'
    | '/admin/shows'
    | '/admin/studio'
    | '/admin/symbols'
    | '/admin/users'
    | '/articles/$slug'
    | '/auth/callback'
    | '/auth/reset-password'
    | '/auth/sign-in'
    | '/auth/sign-up'
    | '/auth/update-password'
    | '/auth/verify'
    | '/creator/analytics'
    | '/creator/application-status'
    | '/creator/assets'
    | '/creator/content'
    | '/creator/live'
    | '/creator/settings'
    | '/creator/shows'
    | '/creator/studio'
    | '/creator/upload'
    | '/creator/write'
    | '/egress/$slug'
    | '/live/$slug'
    | '/onboarding/creator'
    | '/onboarding/subscriber'
    | '/onboarding/welcome'
    | '/studio/$slug'
    | '/subscriber/contributors'
    | '/subscriber/discover'
    | '/subscriber/feed'
    | '/subscriber/history'
    | '/subscriber/saved'
    | '/subscriber/settings'
    | '/subscriber/welcome'
    | '/videos/$slug'
    | '/admin/'
    | '/creator/'
    | '/subscriber/'
    | '/subscriber/creators/$username'
    | '/subscriber/history/reading'
    | '/subscriber/history/watching'
    | '/creator/content/'
    | '/subscriber/history/'
    | '/creator/content/$contentId/edit'
    | '/creator/content/$contentId/preview'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/403'
    | '/404'
    | '/donate'
    | '/subscribe'
    | '/suspended'
    | '/admin/applications'
    | '/admin/audit'
    | '/admin/categories'
    | '/admin/content'
    | '/admin/copy'
    | '/admin/corrections'
    | '/admin/invites'
    | '/admin/live'
    | '/admin/masthead'
    | '/admin/menu'
    | '/admin/picks'
    | '/admin/shows'
    | '/admin/studio'
    | '/admin/symbols'
    | '/admin/users'
    | '/articles/$slug'
    | '/auth/callback'
    | '/auth/reset-password'
    | '/auth/sign-in'
    | '/auth/sign-up'
    | '/auth/update-password'
    | '/auth/verify'
    | '/creator/analytics'
    | '/creator/application-status'
    | '/creator/assets'
    | '/creator/live'
    | '/creator/settings'
    | '/creator/shows'
    | '/creator/studio'
    | '/creator/upload'
    | '/creator/write'
    | '/egress/$slug'
    | '/live/$slug'
    | '/onboarding/creator'
    | '/onboarding/subscriber'
    | '/onboarding/welcome'
    | '/studio/$slug'
    | '/subscriber/contributors'
    | '/subscriber/discover'
    | '/subscriber/feed'
    | '/subscriber/saved'
    | '/subscriber/settings'
    | '/subscriber/welcome'
    | '/videos/$slug'
    | '/admin'
    | '/creator'
    | '/subscriber'
    | '/subscriber/creators/$username'
    | '/subscriber/history/reading'
    | '/subscriber/history/watching'
    | '/creator/content'
    | '/subscriber/history'
    | '/creator/content/$contentId/edit'
    | '/creator/content/$contentId/preview'
  id:
    | '__root__'
    | '/'
    | '/403'
    | '/404'
    | '/admin'
    | '/creator'
    | '/donate'
    | '/subscribe'
    | '/subscriber'
    | '/suspended'
    | '/admin/applications'
    | '/admin/audit'
    | '/admin/categories'
    | '/admin/content'
    | '/admin/copy'
    | '/admin/corrections'
    | '/admin/invites'
    | '/admin/live'
    | '/admin/masthead'
    | '/admin/menu'
    | '/admin/picks'
    | '/admin/shows'
    | '/admin/studio'
    | '/admin/symbols'
    | '/admin/users'
    | '/articles/$slug'
    | '/auth/callback'
    | '/auth/reset-password'
    | '/auth/sign-in'
    | '/auth/sign-up'
    | '/auth/update-password'
    | '/auth/verify'
    | '/creator/analytics'
    | '/creator/application-status'
    | '/creator/assets'
    | '/creator/content'
    | '/creator/live'
    | '/creator/settings'
    | '/creator/shows'
    | '/creator/studio'
    | '/creator/upload'
    | '/creator/write'
    | '/egress/$slug'
    | '/live/$slug'
    | '/onboarding/creator'
    | '/onboarding/subscriber'
    | '/onboarding/welcome'
    | '/studio/$slug'
    | '/subscriber/contributors'
    | '/subscriber/discover'
    | '/subscriber/feed'
    | '/subscriber/history'
    | '/subscriber/saved'
    | '/subscriber/settings'
    | '/subscriber/welcome'
    | '/videos/$slug'
    | '/admin/'
    | '/creator/'
    | '/subscriber/'
    | '/subscriber/creators/$username'
    | '/subscriber/history/reading'
    | '/subscriber/history/watching'
    | '/creator/content/'
    | '/subscriber/history/'
    | '/creator/content/$contentId/edit'
    | '/creator/content/$contentId/preview'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  R403Route: typeof R403Route
  R404Route: typeof R404Route
  AdminRoute: typeof AdminRouteWithChildren
  CreatorRoute: typeof CreatorRouteWithChildren
  DonateRoute: typeof DonateRoute
  SubscribeRoute: typeof SubscribeRoute
  SubscriberRoute: typeof SubscriberRouteWithChildren
  SuspendedRoute: typeof SuspendedRoute
  ArticlesSlugRoute: typeof ArticlesSlugRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthSignInRoute: typeof AuthSignInRoute
  AuthSignUpRoute: typeof AuthSignUpRoute
  AuthUpdatePasswordRoute: typeof AuthUpdatePasswordRoute
  AuthVerifyRoute: typeof AuthVerifyRoute
  EgressSlugRoute: typeof EgressSlugRoute
  LiveSlugRoute: typeof LiveSlugRoute
  OnboardingCreatorRoute: typeof OnboardingCreatorRoute
  OnboardingSubscriberRoute: typeof OnboardingSubscriberRoute
  OnboardingWelcomeRoute: typeof OnboardingWelcomeRoute
  StudioSlugRoute: typeof StudioSlugRoute
  VideosSlugRoute: typeof VideosSlugRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/suspended': {
      id: '/suspended'
      path: '/suspended'
      fullPath: '/suspended'
      preLoaderRoute: typeof SuspendedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/subscriber': {
      id: '/subscriber'
      path: '/subscriber'
      fullPath: '/subscriber'
      preLoaderRoute: typeof SubscriberRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/subscribe': {
      id: '/subscribe'
      path: '/subscribe'
      fullPath: '/subscribe'
      preLoaderRoute: typeof SubscribeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/donate': {
      id: '/donate'
      path: '/donate'
      fullPath: '/donate'
      preLoaderRoute: typeof DonateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/creator': {
      id: '/creator'
      path: '/creator'
      fullPath: '/creator'
      preLoaderRoute: typeof CreatorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/404': {
      id: '/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof R404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/403': {
      id: '/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof R403RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/subscriber/': {
      id: '/subscriber/'
      path: '/'
      fullPath: '/subscriber/'
      preLoaderRoute: typeof SubscriberIndexRouteImport
      parentRoute: typeof SubscriberRoute
    }
    '/creator/': {
      id: '/creator/'
      path: '/'
      fullPath: '/creator/'
      preLoaderRoute: typeof CreatorIndexRouteImport
      parentRoute: typeof CreatorRoute
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/videos/$slug': {
      id: '/videos/$slug'
      path: '/videos/$slug'
      fullPath: '/videos/$slug'
      preLoaderRoute: typeof VideosSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/subscriber/welcome': {
      id: '/subscriber/welcome'
      path: '/welcome'
      fullPath: '/subscriber/welcome'
      preLoaderRoute: typeof SubscriberWelcomeRouteImport
      parentRoute: typeof SubscriberRoute
    }
    '/subscriber/settings': {
      id: '/subscriber/settings'
      path: '/settings'
      fullPath: '/subscriber/settings'
      preLoaderRoute: typeof SubscriberSettingsRouteImport
      parentRoute: typeof SubscriberRoute
    }
    '/subscriber/saved': {
      id: '/subscriber/saved'
      path: '/saved'
      fullPath: '/subscriber/saved'
      preLoaderRoute: typeof SubscriberSavedRouteImport
      parentRoute: typeof SubscriberRoute
    }
    '/subscriber/history': {
      id: '/subscriber/history'
      path: '/history'
      fullPath: '/subscriber/history'
      preLoaderRoute: typeof SubscriberHistoryRouteImport
      parentRoute: typeof SubscriberRoute
    }
    '/subscriber/feed': {
      id: '/subscriber/feed'
      path: '/feed'
      fullPath: '/subscriber/feed'
      preLoaderRoute: typeof SubscriberFeedRouteImport
      parentRoute: typeof SubscriberRoute
    }
    '/subscriber/discover': {
      id: '/subscriber/discover'
      path: '/discover'
      fullPath: '/subscriber/discover'
      preLoaderRoute: typeof SubscriberDiscoverRouteImport
      parentRoute: typeof SubscriberRoute
    }
    '/subscriber/contributors': {
      id: '/subscriber/contributors'
      path: '/contributors'
      fullPath: '/subscriber/contributors'
      preLoaderRoute: typeof SubscriberContributorsRouteImport
      parentRoute: typeof SubscriberRoute
    }
    '/studio/$slug': {
      id: '/studio/$slug'
      path: '/studio/$slug'
      fullPath: '/studio/$slug'
      preLoaderRoute: typeof StudioSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/welcome': {
      id: '/onboarding/welcome'
      path: '/onboarding/welcome'
      fullPath: '/onboarding/welcome'
      preLoaderRoute: typeof OnboardingWelcomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/subscriber': {
      id: '/onboarding/subscriber'
      path: '/onboarding/subscriber'
      fullPath: '/onboarding/subscriber'
      preLoaderRoute: typeof OnboardingSubscriberRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/creator': {
      id: '/onboarding/creator'
      path: '/onboarding/creator'
      fullPath: '/onboarding/creator'
      preLoaderRoute: typeof OnboardingCreatorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/live/$slug': {
      id: '/live/$slug'
      path: '/live/$slug'
      fullPath: '/live/$slug'
      preLoaderRoute: typeof LiveSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/egress/$slug': {
      id: '/egress/$slug'
      path: '/egress/$slug'
      fullPath: '/egress/$slug'
      preLoaderRoute: typeof EgressSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/creator/write': {
      id: '/creator/write'
      path: '/write'
      fullPath: '/creator/write'
      preLoaderRoute: typeof CreatorWriteRouteImport
      parentRoute: typeof CreatorRoute
    }
    '/creator/upload': {
      id: '/creator/upload'
      path: '/upload'
      fullPath: '/creator/upload'
      preLoaderRoute: typeof CreatorUploadRouteImport
      parentRoute: typeof CreatorRoute
    }
    '/creator/studio': {
      id: '/creator/studio'
      path: '/studio'
      fullPath: '/creator/studio'
      preLoaderRoute: typeof CreatorStudioRouteImport
      parentRoute: typeof CreatorRoute
    }
    '/creator/shows': {
      id: '/creator/shows'
      path: '/shows'
      fullPath: '/creator/shows'
      preLoaderRoute: typeof CreatorShowsRouteImport
      parentRoute: typeof CreatorRoute
    }
    '/creator/settings': {
      id: '/creator/settings'
      path: '/settings'
      fullPath: '/creator/settings'
      preLoaderRoute: typeof CreatorSettingsRouteImport
      parentRoute: typeof CreatorRoute
    }
    '/creator/live': {
      id: '/creator/live'
      path: '/live'
      fullPath: '/creator/live'
      preLoaderRoute: typeof CreatorLiveRouteImport
      parentRoute: typeof CreatorRoute
    }
    '/creator/content': {
      id: '/creator/content'
      path: '/content'
      fullPath: '/creator/content'
      preLoaderRoute: typeof CreatorContentRouteImport
      parentRoute: typeof CreatorRoute
    }
    '/creator/assets': {
      id: '/creator/assets'
      path: '/assets'
      fullPath: '/creator/assets'
      preLoaderRoute: typeof CreatorAssetsRouteImport
      parentRoute: typeof CreatorRoute
    }
    '/creator/application-status': {
      id: '/creator/application-status'
      path: '/application-status'
      fullPath: '/creator/application-status'
      preLoaderRoute: typeof CreatorApplicationStatusRouteImport
      parentRoute: typeof CreatorRoute
    }
    '/creator/analytics': {
      id: '/creator/analytics'
      path: '/analytics'
      fullPath: '/creator/analytics'
      preLoaderRoute: typeof CreatorAnalyticsRouteImport
      parentRoute: typeof CreatorRoute
    }
    '/auth/verify': {
      id: '/auth/verify'
      path: '/auth/verify'
      fullPath: '/auth/verify'
      preLoaderRoute: typeof AuthVerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/update-password': {
      id: '/auth/update-password'
      path: '/auth/update-password'
      fullPath: '/auth/update-password'
      preLoaderRoute: typeof AuthUpdatePasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/sign-up': {
      id: '/auth/sign-up'
      path: '/auth/sign-up'
      fullPath: '/auth/sign-up'
      preLoaderRoute: typeof AuthSignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/sign-in': {
      id: '/auth/sign-in'
      path: '/auth/sign-in'
      fullPath: '/auth/sign-in'
      preLoaderRoute: typeof AuthSignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/reset-password': {
      id: '/auth/reset-password'
      path: '/auth/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/articles/$slug': {
      id: '/articles/$slug'
      path: '/articles/$slug'
      fullPath: '/articles/$slug'
      preLoaderRoute: typeof ArticlesSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/symbols': {
      id: '/admin/symbols'
      path: '/symbols'
      fullPath: '/admin/symbols'
      preLoaderRoute: typeof AdminSymbolsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/studio': {
      id: '/admin/studio'
      path: '/studio'
      fullPath: '/admin/studio'
      preLoaderRoute: typeof AdminStudioRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/shows': {
      id: '/admin/shows'
      path: '/shows'
      fullPath: '/admin/shows'
      preLoaderRoute: typeof AdminShowsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/picks': {
      id: '/admin/picks'
      path: '/picks'
      fullPath: '/admin/picks'
      preLoaderRoute: typeof AdminPicksRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/menu': {
      id: '/admin/menu'
      path: '/menu'
      fullPath: '/admin/menu'
      preLoaderRoute: typeof AdminMenuRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/masthead': {
      id: '/admin/masthead'
      path: '/masthead'
      fullPath: '/admin/masthead'
      preLoaderRoute: typeof AdminMastheadRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/live': {
      id: '/admin/live'
      path: '/live'
      fullPath: '/admin/live'
      preLoaderRoute: typeof AdminLiveRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/invites': {
      id: '/admin/invites'
      path: '/invites'
      fullPath: '/admin/invites'
      preLoaderRoute: typeof AdminInvitesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/corrections': {
      id: '/admin/corrections'
      path: '/corrections'
      fullPath: '/admin/corrections'
      preLoaderRoute: typeof AdminCorrectionsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/copy': {
      id: '/admin/copy'
      path: '/copy'
      fullPath: '/admin/copy'
      preLoaderRoute: typeof AdminCopyRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/content': {
      id: '/admin/content'
      path: '/content'
      fullPath: '/admin/content'
      preLoaderRoute: typeof AdminContentRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/categories': {
      id: '/admin/categories'
      path: '/categories'
      fullPath: '/admin/categories'
      preLoaderRoute: typeof AdminCategoriesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/audit': {
      id: '/admin/audit'
      path: '/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof AdminAuditRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/applications': {
      id: '/admin/applications'
      path: '/applications'
      fullPath: '/admin/applications'
      preLoaderRoute: typeof AdminApplicationsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/subscriber/history/': {
      id: '/subscriber/history/'
      path: '/'
      fullPath: '/subscriber/history/'
      preLoaderRoute: typeof SubscriberHistoryIndexRouteImport
      parentRoute: typeof SubscriberHistoryRoute
    }
    '/creator/content/': {
      id: '/creator/content/'
      path: '/'
      fullPath: '/creator/content/'
      preLoaderRoute: typeof CreatorContentIndexRouteImport
      parentRoute: typeof CreatorContentRoute
    }
    '/subscriber/history/watching': {
      id: '/subscriber/history/watching'
      path: '/watching'
      fullPath: '/subscriber/history/watching'
      preLoaderRoute: typeof SubscriberHistoryWatchingRouteImport
      parentRoute: typeof SubscriberHistoryRoute
    }
    '/subscriber/history/reading': {
      id: '/subscriber/history/reading'
      path: '/reading'
      fullPath: '/subscriber/history/reading'
      preLoaderRoute: typeof SubscriberHistoryReadingRouteImport
      parentRoute: typeof SubscriberHistoryRoute
    }
    '/subscriber/creators/$username': {
      id: '/subscriber/creators/$username'
      path: '/creators/$username'
      fullPath: '/subscriber/creators/$username'
      preLoaderRoute: typeof SubscriberCreatorsUsernameRouteImport
      parentRoute: typeof SubscriberRoute
    }
    '/creator/content/$contentId/preview': {
      id: '/creator/content/$contentId/preview'
      path: '/$contentId/preview'
      fullPath: '/creator/content/$contentId/preview'
      preLoaderRoute: typeof CreatorContentContentIdPreviewRouteImport
      parentRoute: typeof CreatorContentRoute
    }
    '/creator/content/$contentId/edit': {
      id: '/creator/content/$contentId/edit'
      path: '/$contentId/edit'
      fullPath: '/creator/content/$contentId/edit'
      preLoaderRoute: typeof CreatorContentContentIdEditRouteImport
      parentRoute: typeof CreatorContentRoute
    }
  }
}

interface AdminRouteChildren {
  AdminApplicationsRoute: typeof AdminApplicationsRoute
  AdminAuditRoute: typeof AdminAuditRoute
  AdminCategoriesRoute: typeof AdminCategoriesRoute
  AdminContentRoute: typeof AdminContentRoute
  AdminCopyRoute: typeof AdminCopyRoute
  AdminCorrectionsRoute: typeof AdminCorrectionsRoute
  AdminInvitesRoute: typeof AdminInvitesRoute
  AdminLiveRoute: typeof AdminLiveRoute
  AdminMastheadRoute: typeof AdminMastheadRoute
  AdminMenuRoute: typeof AdminMenuRoute
  AdminPicksRoute: typeof AdminPicksRoute
  AdminShowsRoute: typeof AdminShowsRoute
  AdminStudioRoute: typeof AdminStudioRoute
  AdminSymbolsRoute: typeof AdminSymbolsRoute
  AdminUsersRoute: typeof AdminUsersRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminApplicationsRoute: AdminApplicationsRoute,
  AdminAuditRoute: AdminAuditRoute,
  AdminCategoriesRoute: AdminCategoriesRoute,
  AdminContentRoute: AdminContentRoute,
  AdminCopyRoute: AdminCopyRoute,
  AdminCorrectionsRoute: AdminCorrectionsRoute,
  AdminInvitesRoute: AdminInvitesRoute,
  AdminLiveRoute: AdminLiveRoute,
  AdminMastheadRoute: AdminMastheadRoute,
  AdminMenuRoute: AdminMenuRoute,
  AdminPicksRoute: AdminPicksRoute,
  AdminShowsRoute: AdminShowsRoute,
  AdminStudioRoute: AdminStudioRoute,
  AdminSymbolsRoute: AdminSymbolsRoute,
  AdminUsersRoute: AdminUsersRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface CreatorContentRouteChildren {
  CreatorContentIndexRoute: typeof CreatorContentIndexRoute
  CreatorContentContentIdEditRoute: typeof CreatorContentContentIdEditRoute
  CreatorContentContentIdPreviewRoute: typeof CreatorContentContentIdPreviewRoute
}

const CreatorContentRouteChildren: CreatorContentRouteChildren = {
  CreatorContentIndexRoute: CreatorContentIndexRoute,
  CreatorContentContentIdEditRoute: CreatorContentContentIdEditRoute,
  CreatorContentContentIdPreviewRoute: CreatorContentContentIdPreviewRoute,
}

const CreatorContentRouteWithChildren = CreatorContentRoute._addFileChildren(
  CreatorContentRouteChildren,
)

interface CreatorRouteChildren {
  CreatorAnalyticsRoute: typeof CreatorAnalyticsRoute
  CreatorApplicationStatusRoute: typeof CreatorApplicationStatusRoute
  CreatorAssetsRoute: typeof CreatorAssetsRoute
  CreatorContentRoute: typeof CreatorContentRouteWithChildren
  CreatorLiveRoute: typeof CreatorLiveRoute
  CreatorSettingsRoute: typeof CreatorSettingsRoute
  CreatorShowsRoute: typeof CreatorShowsRoute
  CreatorStudioRoute: typeof CreatorStudioRoute
  CreatorUploadRoute: typeof CreatorUploadRoute
  CreatorWriteRoute: typeof CreatorWriteRoute
  CreatorIndexRoute: typeof CreatorIndexRoute
}

const CreatorRouteChildren: CreatorRouteChildren = {
  CreatorAnalyticsRoute: CreatorAnalyticsRoute,
  CreatorApplicationStatusRoute: CreatorApplicationStatusRoute,
  CreatorAssetsRoute: CreatorAssetsRoute,
  CreatorContentRoute: CreatorContentRouteWithChildren,
  CreatorLiveRoute: CreatorLiveRoute,
  CreatorSettingsRoute: CreatorSettingsRoute,
  CreatorShowsRoute: CreatorShowsRoute,
  CreatorStudioRoute: CreatorStudioRoute,
  CreatorUploadRoute: CreatorUploadRoute,
  CreatorWriteRoute: CreatorWriteRoute,
  CreatorIndexRoute: CreatorIndexRoute,
}

const CreatorRouteWithChildren =
  CreatorRoute._addFileChildren(CreatorRouteChildren)

interface SubscriberHistoryRouteChildren {
  SubscriberHistoryReadingRoute: typeof SubscriberHistoryReadingRoute
  SubscriberHistoryWatchingRoute: typeof SubscriberHistoryWatchingRoute
  SubscriberHistoryIndexRoute: typeof SubscriberHistoryIndexRoute
}

const SubscriberHistoryRouteChildren: SubscriberHistoryRouteChildren = {
  SubscriberHistoryReadingRoute: SubscriberHistoryReadingRoute,
  SubscriberHistoryWatchingRoute: SubscriberHistoryWatchingRoute,
  SubscriberHistoryIndexRoute: SubscriberHistoryIndexRoute,
}

const SubscriberHistoryRouteWithChildren =
  SubscriberHistoryRoute._addFileChildren(SubscriberHistoryRouteChildren)

interface SubscriberRouteChildren {
  SubscriberContributorsRoute: typeof SubscriberContributorsRoute
  SubscriberDiscoverRoute: typeof SubscriberDiscoverRoute
  SubscriberFeedRoute: typeof SubscriberFeedRoute
  SubscriberHistoryRoute: typeof SubscriberHistoryRouteWithChildren
  SubscriberSavedRoute: typeof SubscriberSavedRoute
  SubscriberSettingsRoute: typeof SubscriberSettingsRoute
  SubscriberWelcomeRoute: typeof SubscriberWelcomeRoute
  SubscriberIndexRoute: typeof SubscriberIndexRoute
  SubscriberCreatorsUsernameRoute: typeof SubscriberCreatorsUsernameRoute
}

const SubscriberRouteChildren: SubscriberRouteChildren = {
  SubscriberContributorsRoute: SubscriberContributorsRoute,
  SubscriberDiscoverRoute: SubscriberDiscoverRoute,
  SubscriberFeedRoute: SubscriberFeedRoute,
  SubscriberHistoryRoute: SubscriberHistoryRouteWithChildren,
  SubscriberSavedRoute: SubscriberSavedRoute,
  SubscriberSettingsRoute: SubscriberSettingsRoute,
  SubscriberWelcomeRoute: SubscriberWelcomeRoute,
  SubscriberIndexRoute: SubscriberIndexRoute,
  SubscriberCreatorsUsernameRoute: SubscriberCreatorsUsernameRoute,
}

const SubscriberRouteWithChildren = SubscriberRoute._addFileChildren(
  SubscriberRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  R403Route: R403Route,
  R404Route: R404Route,
  AdminRoute: AdminRouteWithChildren,
  CreatorRoute: CreatorRouteWithChildren,
  DonateRoute: DonateRoute,
  SubscribeRoute: SubscribeRoute,
  SubscriberRoute: SubscriberRouteWithChildren,
  SuspendedRoute: SuspendedRoute,
  ArticlesSlugRoute: ArticlesSlugRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthSignInRoute: AuthSignInRoute,
  AuthSignUpRoute: AuthSignUpRoute,
  AuthUpdatePasswordRoute: AuthUpdatePasswordRoute,
  AuthVerifyRoute: AuthVerifyRoute,
  EgressSlugRoute: EgressSlugRoute,
  LiveSlugRoute: LiveSlugRoute,
  OnboardingCreatorRoute: OnboardingCreatorRoute,
  OnboardingSubscriberRoute: OnboardingSubscriberRoute,
  OnboardingWelcomeRoute: OnboardingWelcomeRoute,
  StudioSlugRoute: StudioSlugRoute,
  VideosSlugRoute: VideosSlugRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
